module.exports = __webpack_public_path__ + "img/downsort.79a76027.svg";